import { Box, forwardRef } from '@chakra-ui/react';

const AlertDescription = forwardRef<any, 'div'>((props, ref) => {
	return <Box display="inline" lineHeight="base" ref={ref} {...props} />;
});

AlertDescription.displayName = 'AlertDescription';

export { AlertDescription };
